import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { AreaName } from 'domain/constants';
import { OperationType } from 'library/models/enums/OperationType';
import { createArea } from 'library/utils/helpers/AreaHelper';

import LazyRouteElement from './common/LazyRoute';
import { isServiceContractFeatureOn } from './getUnitServicesAreaRoutes';
import { connectServiceContractPath } from './urls/RouteUrls';

const ConnectServiceContractPage = lazy(
	() => import('pages/serviceContracts/ConnectServiceContractPage')
);

export const getServiceContractRoutes = (): React.JSX.Element[] =>
	isServiceContractFeatureOn()
		? [
				<Route
					key={'connectServiceContract'}
					path={connectServiceContractPath}
					element={
						<LazyRouteElement
							area={createArea(
								AreaName.ServiceContractsManage,
								OperationType.Write
							)}
							Component={ConnectServiceContractPage}
							path={connectServiceContractPath}
						/>
					}
				/>,
			]
		: [];
